var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTennisCourt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_198_1217)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M400 0H0V180H400V0Z",
    fill: "#488C31"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M379.805 17.4539H21.9922V165.091H379.805V17.4539Z",
    fill: "url(#paint0_radial_198_1217)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 16.8237V165.091H380.57V16.8237H20.5ZM379.086 17.9383V31.9142H21.9922V17.9383H379.086ZM379.086 90.5253H373.875V91.6399H379.086V149.142H289.195V33.0229H379.086V90.5253ZM21.9922 90.5253V33.0229H112.883V149.137H21.9922V91.6341H26.5469V90.5195H21.9922V90.5253ZM287.703 90.397H114.367V33.0229H287.703V90.397ZM114.367 91.5115H287.703V149.137H114.367V91.5115ZM21.9922 163.976V150.251H379.086V163.976H21.9922Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M200.008 13.4216V14.542H201.672V13.4216C202.914 13.1531 203.82 12.2953 203.82 11.2858C203.82 10.0545 202.484 9.0625 200.844 9.0625C199.203 9.0625 197.859 10.0604 197.859 11.2858C197.859 12.3012 198.766 13.1531 200.008 13.4216Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M200.844 169.344C199.195 169.344 197.859 170.342 197.859 171.574C197.859 172.805 199.195 173.797 200.844 173.797C202.492 173.797 203.82 172.799 203.82 171.574C203.82 170.348 202.484 169.344 200.844 169.344Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 100.317H200.008V104.046H201.672V100.317Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 122.69H200.008V126.419H201.672V122.69Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 115.232H200.008V118.961H201.672V115.232Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 107.775H200.008V111.504H201.672V107.775Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 130.148H200.008V133.877H201.672V130.148Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 137.605H200.008V141.334H201.672V137.605Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 152.521H200.008V156.25H201.672V152.521Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 159.985H200.008V163.713H201.672V159.985Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 145.063H200.008V148.792H201.672V145.063Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 70.4805H200.008V74.2093H201.672V70.4805Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 33.1921H200.008V36.921H201.672V33.1921Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 92.8594H200.008V96.5882H201.672V92.8594Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 18.2766H200.008V22.0055H201.672V18.2766Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 25.7344H200.008V29.4632H201.672V25.7344Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 48.1074H200.008V51.8363H201.672V48.1074Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 40.6497H200.008V44.3785H201.672V40.6497Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 77.9441H200.008V81.6729H201.672V77.9441Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 85.4019H200.008V89.1307H201.672V85.4019Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 63.0227H200.008V66.7516H201.672V63.0227Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 55.5649H200.008V59.2938H201.672V55.5649Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M201.672 167.442H200.008V169.309H201.672V167.442Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.16
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M379.086 17.6873H21.9922V29.5799H379.086V17.6873Z",
    fill: "#92B61C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.16
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M379.086 40.6265H21.9922V52.5191H379.086V40.6265Z",
    fill: "#92B61C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.16
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M379.086 62.8711H21.9922V74.7637H379.086V62.8711Z",
    fill: "#92B61C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.16
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M379.086 84.865H21.9922V96.7576H379.086V84.865Z",
    fill: "#92B61C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.16
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M379.086 106.859H21.9922V118.751H379.086V106.859Z",
    fill: "#92B61C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.16
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M379.086 129.523H21.9922V141.416H379.086V129.523Z",
    fill: "#92B61C"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.16
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M379.086 152.521H21.9922V164.414H379.086V152.521Z",
    fill: "#92B61C"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_198_1217",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(200.898 91.2722) scale(144.523 107.95)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C9336"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#488C31"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_198_1217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 180,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTennisCourt);
export default __webpack_public_path__ + "static/media/tennis-court.cc3c229921139b3c73565de1e96a40aa.svg";
export { ForwardRef as ReactComponent };